<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">查詢保障細項</h3>
                </div>
                <div v-if="isLoading" class="modal-body">
                    <Message
                        class="my-5 d-flex justify-content-center"
                        loading
                        message="資料讀取中，請稍候..."
                    />
                </div>
                <div v-else class="modal-body">
                    <form class="form">
                        <div class="row">
                            <!-- 十大保障大類 -->
                            <div class="col-12" v-if="data.bigName && data.bigName !== ''">
                                <div class="form-group row">
                                    <label class="col-8 text-left"
                                        for="big-ten">十大保障大類：{{ data.bigName }}</label>
                                </div>
                            </div>
                            <!-- 保障中分類代碼 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-8 text-left"
                                        for="mid-code">保障中分類代碼：{{ data.midCode }}</label>
                                </div>
                            </div>
                            <!-- 保障中分類名稱 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-8 text-left"
                                        for="mid-name">保障中分類名稱：{{ data.midName }}</label>
                                </div>
                            </div>
                            <!-- 保障細項 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-left" for="small-detail">保障細項：</label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <table class="table datatable">
                        <thead>
                            <tr>
                                <th style="width:20%" class="text-center">保障項目編號</th>
                                <th style="width:80%" class="text-center">保障項目說明(細項)</th>
                            </tr>
                        </thead>
                        <tbody v-if="smallCategory.length">
                            <tr v-for="(item, i) in smallCategory" :key="`small-data-${i}`">
                                <td class="text-center">{{ item.sequencenumber }}</td>
                                <td class="text-center">{{ item.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <a @click="doConfirm()" class="btn btn-primary editbtn">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import { querySmallCategoryByCode } from "@/service";

export default {
    name: "SmallCategoryShowModal",
    components: { Message },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object, 
            required: true, 
            default: () => {
                return {
                    bigName: "",
                    midCode: "",
                    midName: "",
                };
            }
        }
    },
    data() {
        return {
            isLoading: true,
            smallCategory: [],
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.isLoading = true;
                this.getSmallCategory();
            }
        },
    },
    methods: {
        async getSmallCategory() {
            await querySmallCategoryByCode(
                this.$store.state.userInfo.id,
                this.data.midCode
            ).then((result) => {
                if (result.header && result.header.status == "200") {
                    this.smallCategory = result.data;
                } else {
                    this.smallCategory = [];
                }
                this.isLoading = false;
            });
        },
        doConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>

<style scoped>
.modal.fade .modal-body {
    min-height: auto;
}

.editbtn {
    width: 120px;
    height: 40px;
}
</style>